import {sendErrorLog} from "@/api/chatApi";

interface DBHelperConstructorOptions {
  name: string
  engine: Storage
}

export class DBHelper {
  name: string
  engine: Storage

  constructor(options?: DBHelperConstructorOptions) {
    const { name = 'CHATBOT_', engine = localStorage } = options || {}
    this.name = name
    this.engine = engine
  }

  get size() {
    const data = Object.keys(this.engine).concat(Object.values(this.engine))
    return new Blob(data).size
  }

  getKey(key: string) {
    return this.name + key.toUpperCase()
  }

  getItem(key: string) {
    return this.engine.getItem(this.getKey(key))
  }

  setItem(key: string, val: string) {
    try {
      this.engine.setItem(this.getKey(key), val)  
    }catch (e:any) {
      sendErrorLog('', '', 'UNKNOWN_CATEGORY',`${e.message} value length: ${val.length} ;${e.stack}`);
      throw e;
    }
  }

  removeItem(key: string) {
    this.engine.removeItem(this.getKey(key))
  }

  /**
   * @param key {string}
   * @returns {any}
   */
  getJson(key: string) {
    return JSON.parse(this.getItem(key) || 'null')
  }

  /**
   * @param key {string}
   * @param val
   */
  setJson(key: string, val: any) {
    const valStr = JSON.stringify(val)
    this.setItem(key, valStr)
  }
}

export default new DBHelper()
